"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconCompare = function IconCompare(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0244 16.8224C45.0283 16.8959 45.0281 16.9696 45.0239 17.043C45.012 17.2518 44.9681 17.452 44.8971 17.6387C44.7998 17.8951 44.6479 18.1356 44.4414 18.3421L37.8417 24.9417C37.0607 25.7228 35.7943 25.7228 35.0133 24.9417C34.2322 24.1607 34.2322 22.8944 35.0133 22.1133L38.1988 18.9278H18.8283C17.7238 18.9278 16.8283 18.0324 16.8283 16.9278C16.8283 15.8232 17.7238 14.9278 18.8283 14.9278L38.1987 14.9278L35.0133 11.7424C34.2322 10.9613 34.2322 9.69502 35.0133 8.91397C35.7943 8.13292 37.0607 8.13292 37.8417 8.91397L44.4411 15.5134L44.4414 15.5136C44.8051 15.8773 44.9994 16.3463 45.0244 16.8224Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83058 32.0332C4.82673 31.9598 4.82691 31.8861 4.83112 31.8126C4.84297 31.6039 4.88684 31.4037 4.9579 31.2169C5.0552 30.9605 5.20711 30.7201 5.41361 30.5136L12.0133 23.9139C12.7943 23.1329 14.0607 23.1329 14.8417 23.9139C15.6227 24.695 15.6227 25.9613 14.8417 26.7423L11.6562 29.9278L31.0266 29.9278C32.1312 29.9278 33.0266 30.8233 33.0266 31.9278C33.0266 33.0324 32.1312 33.9278 31.0266 33.9278L11.6563 33.9278L14.8417 37.1133C15.6227 37.8943 15.6227 39.1606 14.8417 39.9417C14.0607 40.7227 12.7943 40.7227 12.0133 39.9417L5.41389 33.3423L5.41361 33.342C5.04991 32.9783 4.85557 32.5094 4.83058 32.0332Z",
    fill: color
  }));
};

IconCompare.defaultProps = {
  color: 'black',
  size: 30
};
IconCompare.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconCompare;
exports.default = _default;